// extracted by mini-css-extract-plugin
export default {"heading":"Chapter_heading__myqw1","content":"Chapter_content__+nL2b"};